const notNull = (valueExpr) => {
  if (valueExpr === null || valueExpr === undefined) {
    return false;
  }
  return true;
};

export default notNull;
